var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { useRequestState } from "./useRequestState";
var LIST_KEY = "getPlanCreationBenefits";
var CREATE_KEY = "postPlanCreationBenefit";
var UPDATE_KEY = "patchPlanCreationBenefit";
export var usePlanBenefits = function () {
    var dispatch = useDispatch();
    var list = useRequestState(LIST_KEY);
    var create = useRequestState(CREATE_KEY);
    var update = useRequestState(UPDATE_KEY);
    var fetchBenefits = function (params) {
        dispatch(customRequestApis({
            requestKey: LIST_KEY,
            method: "GET",
            path: "/asg/Api/V1/Benefit",
            queryParams: __assign({}, params),
        }));
    };
    var createBenefit = function (body) {
        dispatch(customRequestApis({
            requestKey: CREATE_KEY,
            method: "POST",
            path: "/asg/Api/V1/Benefit",
            body: { data: body },
        }));
    };
    var updateBenefit = function (_a) {
        var id = _a.id, body = _a.body;
        dispatch(customRequestApis({
            requestKey: UPDATE_KEY,
            method: "PATCH",
            path: "/asg/Api/V1/Benefit/".concat(id),
            body: { data: body },
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(LIST_KEY));
            dispatch(clearCustomRequest(CREATE_KEY));
            dispatch(clearCustomRequest(UPDATE_KEY));
        };
    }, []);
    return {
        fetchBenefits: fetchBenefits,
        createBenefit: createBenefit,
        updateBenefit: updateBenefit,
        benefits: list.data,
        createdBenefit: create.data,
        updatedBenefit: update.data,
        loading: list.loading || create.loading || update.loading,
        errorList: list.error,
        errorCreate: create.error,
        errorUpdate: update.error,
        clearCreated: function () { return dispatch(clearCustomRequest(CREATE_KEY)); },
        clearUpdated: function () { return dispatch(clearCustomRequest(UPDATE_KEY)); },
    };
};
